/* eslint-disable import/prefer-default-export */

'use client';

import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { Link } from 'react-router';
import { Eye } from 'lucide-react';
import PaymentStatusBadge from '../../../components/ui/badge';
import { IContactPerson, IInvoice } from '../../../types/types';

export const columns: ColumnDef<IContactPerson | []>[] = [
  {
    accessorKey: 'name',
    header: () => <div className="text-xs lg:text-base">Name</div>,
    cell: ({ row }) => <div className="text-xs lg:text-base">{row.getValue('name')}</div>,
  },
  {
    accessorKey: 'position',
    header: () => <div className="text-xs lg:text-base">Position</div>,
    cell: ({ row }) => <div className="font-medium text-xs lg:text-base">{row.getValue('position')}</div>,
  },
  {
    accessorKey: 'phone',
    header: () => <div className="text-xs lg:text-base">Phone</div>,
    cell: ({ row }) => <div className="font-medium text-xs lg:text-base">{row.getValue('phone')}</div>,
  },
  {
    accessorKey: 'email',
    header: () => <div className="text-xs lg:text-base">Email</div>,
    cell: ({ row }) => <div className="font-medium text-xs lg:text-base">{row.getValue('email')}</div>,
  },
];

export const columnInvoice: ColumnDef<IInvoice>[] = [
  {
    accessorKey: 'invoice_number',
    header: () => <div className="text-xs lg:text-base">Invoice No.</div>,
    cell: ({ row }) => <div className="text-xs lg:text-base">{row.getValue('invoice_number')}</div>,
  },
  {
    accessorKey: 'status_payment',
    header: () => <div className="text-xs lg:text-base">Payment Status</div>,
    cell: ({ row }) => (
      <div>
        <PaymentStatusBadge status={row.getValue('status_payment')} />
      </div>
    ),
  },
  {
    accessorKey: 'amount_due',
    header: () => <div className="text-center text-xs lg:text-base">Amount</div>,
    cell: ({ row }) => {
      const amount = parseFloat(row.getValue('amount_due'));

      const formatted = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(amount);

      return <div className="text-right font-medium text-xs lg:text-base">{formatted}</div>;
    },
  },
  {
    accessorKey: 'date',
    header: () => <div className="text-xs lg:text-base">Invoice Date</div>,
    cell: ({ row }) => {
      const formattedDate = format(row.getValue('date'), 'LLL dd, y');
      return <div className="text-xs lg:text-base">{formattedDate}</div>;
    },
  },
  {
    accessorKey: 'due_date',
    header: () => <div className="text-xs lg:text-base">Due Date</div>,
    cell: ({ row }) => {
      const formattedDate = format(row.getValue('due_date'), 'LLL dd, y');
      return <div className="text-xs lg:text-base">{formattedDate}</div>;
    },
  },
  {
    accessorKey: 'invoice_id',
    header: () => <div className="text-xs lg:text-base">View</div>,
    cell: ({ row }) => {
      const invoice = row.original;
      return (
        <Link
          to={`/invoice/view/${invoice.invoice_id}`}
          className="flex gap-[2px] items-center hover:underline text-xs lg:text-base"
        >
          <Eye className="w-4 h-4 lg:w-6 lg:h-6" />
          View
        </Link>
      );
    },
  },
];
